// extracted by mini-css-extract-plugin
module.exports = {"lightGray":"#D6D6D7","card":"Card_card__2jlaB","highlighted":"Card_highlighted__1sdjs","orange":"Card_orange__hCVYv","blue":"Card_blue__3ggsz","pink":"Card_pink___Pr2C"};